import { render, staticRenderFns } from "./InspeccionIndex.vue?vue&type=template&id=48e8eb1a"
import script from "./InspeccionIndex.vue?vue&type=script&lang=js"
export * from "./InspeccionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports